import { CommonMessages } from "../messages/validationMessages"
import * as Yup from 'yup'
import { userType } from "../utils/enums"

const parseCampaignDate = (value: unknown): Date | null => {
    if (!value) return null;

    if (value instanceof Date && !isNaN(value.getTime())) {
        return value;
    }

    if (typeof value === "string") {
        const trimmedValue = value.trim();
        if (!trimmedValue) return null;

        // Handles values entered/displayed as MM/DD/YYYY in the form.
        const mdYMatch = trimmedValue.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
        if (mdYMatch) {
            const month = Number(mdYMatch[1]);
            const day = Number(mdYMatch[2]);
            const year = Number(mdYMatch[3]);
            const parsedDate = new Date(year, month - 1, day);

            if (
                parsedDate.getFullYear() === year &&
                parsedDate.getMonth() === month - 1 &&
                parsedDate.getDate() === day
            ) {
                return parsedDate;
            }
        }

        const fallbackDate = new Date(trimmedValue);
        return isNaN(fallbackDate.getTime()) ? null : fallbackDate;
    }

    return null;
};

export const addCampaignSchema = Yup.object().shape({
    assignedlocation: Yup.string().required(CommonMessages.location_required),
    washname: Yup.string().required(CommonMessages.washname_required),
    campaignname: Yup.string().required(CommonMessages.campaignname_required),
    multipleCodeGeneration:Yup.boolean(),
    generatecode: Yup.string().when("multipleCodeGeneration",{
        is:(val: boolean) => val === false ,
        then: (schema) =>
            schema.required(CommonMessages.campaigncode_required),
        otherwise: (schema) => schema.notRequired(),
    }),
    noOfCodes:Yup.number().when("multipleCodeGeneration",{
        is:(val: boolean) => val === true ,
        then: (schema) =>
            schema.required(CommonMessages.campaigncode_required)
                    .min(2, 'Minimum 2 codes are required')
                    .max(5100, 'Maximum 5100 codes are allowed'),
        otherwise: (schema) => schema.notRequired(),
    }),
    campaigndetails: Yup.string().required(CommonMessages.campaigndetails_required),
    discounttype: Yup.string().required(CommonMessages.discounttype_required),
    validFrom: Yup.mixed()
        .test("required", CommonMessages.campaignValidFrom_required, (value) => parseCampaignDate(value) !== null)
        .test(
            "validFrom-not-greater-than-validTo",
            CommonMessages.not_less_than,
            function (value) {
                const { validTo } = this.parent;
                if (!value || !validTo) return true;

                const fromDate = parseCampaignDate(value);
                const toDate = parseCampaignDate(validTo);

                if (!fromDate || !toDate) return true;
                return fromDate <= toDate;
            }
        ),
    validTo: Yup.mixed()
        .test("required", CommonMessages.campaignValidTo_required, (value) => parseCampaignDate(value) !== null)
        .test(
            "validTo-not-less-than-validFrom",
            CommonMessages.not_less_than,
            function (value) {
                const { validFrom } = this.parent;
                if (!value || !validFrom) return true;

                const fromDate = parseCampaignDate(validFrom);
                const toDate = parseCampaignDate(value);

                if (!fromDate || !toDate) return true;
                return toDate >= fromDate;
            }
        ),
    CampaignDuration: Yup.string().required(CommonMessages.campaignDuration_required),
    discount_value: Yup.string().required(CommonMessages.discount_value_required),
    subscriptionType: Yup.string().required(CommonMessages.subscription_type_required),
    userType: Yup.number(), 
    userSubscription: Yup.string().when("userType",{
        is:(val: number) => val == 1 ,
        then: (schema) =>
            schema.required(CommonMessages.user_suscription_required),
        otherwise: (schema) => schema.notRequired(),
    }),

});

